import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AllRoutes from './allRoutes';
import { ThemeProvider } from '@mui/material';
import './i18n/config';
import { LanguageProvider } from './context/language.context';
import { RbacProvider } from './context/rbac.context';
import QueryClientWrapper from './utils/queryClientWrapper';
import { StudentFiltersProvider } from './views/modules/students/contexts/studentFilters.context';
import { BrandingProvider, useBrandingContext } from './context/branding.context';
import { createBrandedTheme } from './design-system/createBrandedTheme';

const ThemedApp: React.FC = () => {
  const { primaryColor, secondaryColor } = useBrandingContext();
  const theme = useMemo(
    () => createBrandedTheme({ primaryColor, secondaryColor }),
    [primaryColor, secondaryColor]
  );

  return (
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <RbacProvider>
          <StudentFiltersProvider>
            <AllRoutes />
          </StudentFiltersProvider>
        </RbacProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientWrapper>
      <BrandingProvider>
        <ThemedApp />
      </BrandingProvider>
    </QueryClientWrapper>
  </React.StrictMode>
);
